import React from "react";
import Layout from "@components/layout";
import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import TextSection from "@components/reviewsGuidelinesPage/TextSection/textSection";

const ReviewsGuidelinesTemplate = ({
  data: {
    reviews_guidelines_hero_heading: {
      0: { text: heroHeading },
    },
    reviews_guidelines_hero_image,
    reviews_guidelines_text
  },
  pageContext: { locale },
}) => {
  return (
    <Layout locale={locale}>
      <SEO
        titleKey="seo.reviews_guidelines.title"
        descriptionKey="seo.reviews_guidelines.description"
        imageUrl={reviews_guidelines_hero_image.url}
        lang={locale}
      />
      <HeroSection
        heroHeading={heroHeading}
        heroImage={reviews_guidelines_hero_image}
        height={240}
      />
      <UniplacesFullContainer>
          <TextSection text={reviews_guidelines_text} />
          <Controls />
      </UniplacesFullContainer>
    </Layout>
  );
};

export default ReviewsGuidelinesTemplate;
